const StorageService = require('./StorageService');

function URLHelper(location) {

    const DASHBOARD_PROD = 'https://dashboards.tenfold.com/';
    const DASHBOARD = 'https://dashboards.tenfold.com/';
    const DASHBOARD_LOCAL = 'http://localhost:3000/';
    const API = 'https://api-canary.tenfold.com/';
    const API_LOCAL = 'http://localhost:3020/';
    const DASHBOARD_USER = 'api/v1/user';
    const SIGN_UP = 'v1/demo/create-organization?apiCall=true';
    const UPDATE_FEATURES = 'api/v1/features/:orgId/saveFeatureToOrg';
    const CREATE_ORG = 'org-management';
    const FIND_ORG = 'v1/demo/find-organization';
    const FIND_DEMO = 'v1/demo/slide-presentation';
    const UPDATE_ORG = 'api/v1/organization/:orgId/updateOrganization';
    const LOGIN = 'login?postAuthDestination=';
    const AUTHORS = 'v1/demo/authors?apiCall=true';
    const FIND_ORGS_BY_NAME = FIND_ORG + '?name=';
    const GUESTS = 'v1/demo/guests';
    const VIEWS = 'v1/demo/views';
    const BEACON = 'v1/demo/beacon';
    const LOGOUT = 'logout';
    const DASHBOARD_LOGIN = 'zendesk/switch_silent/:id/qgn6D19s84J5q57Bqlg8T3X584r4l1gj';
    const FIND_CRM_RECORDS = 'v1/demo/records?name=';

    const useRemote = StorageService.getUseRemote();
    const isLocal = _.isUndefined(useRemote) ? (location.hostname === 'localhost') : !useRemote ;

    const DASHBOARD_DEFAULT = isLocal ? DASHBOARD_LOCAL : DASHBOARD;
    const API_DEFAULT = isLocal ? API_LOCAL : API;
    const DASHBOARD_DEFAULT_P = isLocal ? DASHBOARD_LOCAL : DASHBOARD_PROD;

    this.getDashboard = function (url) {
        return DASHBOARD_DEFAULT + url;
    };

    this.getDemoAnalyticsUrl = () => DASHBOARD_DEFAULT + 'demoanalytics';

    this.getLogout = function () {
        return DASHBOARD_DEFAULT + LOGOUT;
    };

    this.isLocal = function () {
        return isLocal;
    };

    this.getDashboardUser = function () {
        return DASHBOARD_DEFAULT_P + DASHBOARD_USER;
    };

    this.getUpdateOrganization = function (orgId) {
        return DASHBOARD_DEFAULT_P + UPDATE_ORG.replace(':orgId', orgId);
    };

    this.getSignUp = function () {
        return API_DEFAULT + SIGN_UP;
    };

    this.getLogin = function (postAuthDestination) {
        return DASHBOARD_DEFAULT + LOGIN + encodeURIComponent(postAuthDestination || window.location.href);
    };

    this.getUpdateFeature = function (orgId) {
        return DASHBOARD_DEFAULT + UPDATE_FEATURES.replace(':orgId', orgId);
    };

    this.getCreateOrganization = function () {
        return DASHBOARD_DEFAULT_P + CREATE_ORG;
    };

    this.getFindDemo = function (handle) {
        return `${API_DEFAULT}${FIND_DEMO}/${handle}`;
    };

    this.getFindOrganization = function () {
        return API_DEFAULT + FIND_ORG;
    };

    this.getFindOrganizationsByName = function (params) {
        return API_DEFAULT + FIND_ORGS_BY_NAME + encodeURIComponent(params.term);
    };

    this.getAuthors = function (name) {
        return API_DEFAULT + AUTHORS.replace('%name', name || '%name');
    };

    this.getGuestSignUp = function () {
        return API_DEFAULT + GUESTS;
    };

    this.getUserView = function () {
        return API_DEFAULT + VIEWS;
    };

    this.getDashboardLogin = function (id) {
        return DASHBOARD_DEFAULT + DASHBOARD_LOGIN.replace(':id', id);
    };

    this.getDashboardLoginWithToken = function (id) {
        return DASHBOARD_DEFAULT + 'loginWithToken';
    };

    this.getSetupFromUrl = function () {
        var searchParams = new URLSearchParams(location.search);

        var urlFields = [
            'company',
            'username',
            'phoneNumber',
            'customHandle'
        ];

        var setup = {};

        urlFields
            .filter(searchParams.get.bind(searchParams))
            .forEach(function (field) {
                setup[field] = searchParams.get(field);
            });

        var crmModule = searchParams.get('crmModule');
        var crmId = searchParams.get('crmId');

        if (crmModule && crmId) {
            setup.crmAccount = { crmModule, crmId };
        }

        return setup;
    };

    this.getBeacon = function () {
        return API_DEFAULT + BEACON;
    };

    this.getCRMRecords = function (params) {
        return API_DEFAULT + FIND_CRM_RECORDS + encodeURIComponent(params.term);
    };

}

module.exports = new URLHelper(window.location);


//////////////////
// WEBPACK FOOTER
// ./form/components/utils/URLHelper.js
// module id = 4
// module chunks = 0 1